module.exports = __webpack_public_path__ + "23a74befb28a1523581672c696d37b36.svg";